// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"402":"ce0b3c96","862":"e5d3019c"}[chunkId] + ".chunk.js";
};